import './index.css'

import React from 'react'
import Heading from 'components/ui/heading'
import Skeleton from 'components/ui/skeleton'
import Breadcrumbs from './breadcrumbs'
type Props = {
  actions?: React.ReactNode
  breadcrumbs?: {
    content: React.ReactNode
    link: string
  }
  children?: React.ReactNode
  title?: React.ReactNode
  titleBefore?: React.ReactNode
}

/**
 * A header component for pages that displays title, breadcrumbs, actions, and additional content
 * @param actions - Action buttons or elements to display on the right side of the header
 * @param breadcrumbs - Object containing breadcrumb navigation with content and link properties
 * @param children - Additional content to display below the header title and actions
 * @param title - Main title text to display, shows skeleton loader if undefined
 * @param titleBefore - Content to display before the title (e.g., icons, badges)
 * @returns Page header div element with structured layout for title, breadcrumbs, and actions
 */
const PageHeader = ({
  actions,
  breadcrumbs,
  children,
  title,
  titleBefore,
}: Props): React.ReactElement<'div'> => (
  <div className="PageHeader">
    {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
    <div className="PageHeader-title">
      {titleBefore && (
        <div className="PageHeader-title-before">{titleBefore}</div>
      )}
      <Heading>{title === undefined ? <Skeleton /> : title}</Heading>
    </div>
    {actions && <div className="PageHeader-actions">{actions}</div>}
    {children && <div className="PageHeader-content">{children}</div>}
  </div>
)

PageHeader.Breadcrumbs = Breadcrumbs
export default PageHeader
